<div class="card" [ngClass]="{checked: message.checked}" (click)="clickCard.emit()">
  <div class="avatar">
      <lib-svg [icon]="'user_avatar_ico'" *ngIf="message.read"></lib-svg>
      <lib-svg [icon]="'user_avatar_red_ico'" *ngIf="!message.read"></lib-svg>
  </div>
  <div class="body">
    <div class="messageTitle" id="messageTitle">
      <span [ngStyle]="{'font-weight': message.read ? 'normal' : 'bold'}">{{message.title}}</span>
    </div>
    <div class="messageContent" id="messageContent">
      <span>{{message.description}}</span>
    </div>
    <div class="messageTime" id="messageTime">
      <span>{{message.date_description}}</span>
    </div>
  </div>
  <div class="checkbox"> 
    <lib-input-checkbox (click)="clickCheck($event)" [ngModel]="message.checked"></lib-input-checkbox>
  </div>
</div>